(function () {
  const STORAGE_KEY = "appwiz-yash-countdown-end";
  const DURATION_MS = 10 * 60 * 1000;

  function pad(value) {
    return String(value).padStart(2, "0");
  }

  function readEndTime() {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    return stored ? parseInt(stored, 10) : NaN;
  }

  function writeEndTime(endTime) {
    sessionStorage.setItem(STORAGE_KEY, String(endTime));
  }

  function ensureEndTime() {
    let endTime = readEndTime();

    if (Number.isNaN(endTime)) {
      endTime = Date.now() + DURATION_MS;
      writeEndTime(endTime);
    }

    return endTime;
  }

  function getRemainingMs() {
    return ensureEndTime() - Date.now();
  }

  function restart() {
    const endTime = Date.now() + DURATION_MS;
    writeEndTime(endTime);
    return endTime - Date.now();
  }

  function splitTime(remainingMs) {
    const totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000));
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return {
      days: pad(days),
      hours: pad(hours),
      minutes: pad(minutes),
      seconds: pad(seconds),
    };
  }

  function setText(root, selector, value) {
    const el = root.querySelector(selector);
    if (el) {
      el.textContent = value;
    }
  }

  function updateCountdown(root, remainingMs) {
    const timerEl = root.querySelector("[data-appwiz-yash-countdown-timer]");
    const restartBtn = root.querySelector(
      "[data-appwiz-yash-countdown-restart]",
    );
    const expired = remainingMs <= 0;

    if (expired) {
      if (timerEl) {
        timerEl.hidden = true;
      }
      if (restartBtn) {
        restartBtn.hidden = false;
      }
      return;
    }

    if (timerEl) {
      timerEl.hidden = false;
    }
    if (restartBtn) {
      restartBtn.hidden = true;
    }

    const { days, hours, minutes, seconds } = splitTime(remainingMs);
    setText(root, "[data-appwiz-yash-countdown-days]", days);
    setText(root, "[data-appwiz-yash-countdown-hours]", hours);
    setText(root, "[data-appwiz-yash-countdown-minutes]", minutes);
    setText(root, "[data-appwiz-yash-countdown-seconds]", seconds);
  }

  function tick(remainingMs) {
    const ms = typeof remainingMs === "number" ? remainingMs : getRemainingMs();

    document
      .querySelectorAll("[data-appwiz-yash-countdown]")
      .forEach((root) => {
        updateCountdown(root, ms);
      });
  }

  function initCountdown() {
    ensureEndTime();

    document.addEventListener("click", (event) => {
      const restartBtn = event.target.closest(
        "[data-appwiz-yash-countdown-restart]",
      );
      if (!restartBtn) {
        return;
      }

      event.preventDefault();
      const remainingMs = restart();
      tick(remainingMs);
    });

    tick();
    setInterval(tick, 250);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCountdown);
  } else {
    initCountdown();
  }
})();

(function () {
  const CHECKOUT_SELECTOR = ".alpha-appwiz-recharge-direct-checkout";
  const LABEL_SELECTOR = "[data-pp-cta-text], [data-pp-sticky-cta]";

  function getLabel(button) {
    return button.querySelector(LABEL_SELECTOR);
  }

  function rememberButtonLabel(button) {
    const label = getLabel(button);
    if (label) {
      if (!label.getAttribute("data-original-text")) {
        label.setAttribute("data-original-text", label.textContent);
      }
      return;
    }

    if (!button.getAttribute("data-original-html")) {
      button.setAttribute("data-original-html", button.innerHTML);
    }
  }

  function restoreButton(button) {
    button.disabled = false;
    button.style.pointerEvents = "";

    const label = getLabel(button);
    if (label) {
      const originalText = label.getAttribute("data-original-text");
      if (originalText) {
        label.textContent = originalText;
      }
      return;
    }

    const originalHtml = button.getAttribute("data-original-html");
    if (originalHtml) {
      button.innerHTML = originalHtml;
    }
  }

  function resetCheckoutButtons() {
    document.querySelectorAll(CHECKOUT_SELECTOR).forEach(restoreButton);
  }

  function initRechargeCheckout() {
    document.addEventListener("click", (event) => {
      const button = event.target.closest(CHECKOUT_SELECTOR);
      if (!button) {
        return;
      }

      event.preventDefault();

      const variantId = button.getAttribute("data-variant-id");
      const sellingPlanId = button.getAttribute("data-selling-plan-id");
      const quantity = button.getAttribute("data-quantity") || "1";
      const loadingText =
        button.getAttribute("data-loading-text") || "Redirecting...";

      if (!variantId || !sellingPlanId) {
        console.error(
          "alpha-appwiz-recharge-direct-checkout: missing data-variant-id or data-selling-plan-id.",
        );
        return;
      }

      rememberButtonLabel(button);
      button.disabled = true;
      button.style.pointerEvents = "none";

      const label = getLabel(button);
      if (label) {
        label.textContent = loadingText;
      } else {
        button.textContent = loadingText;
      }

      const addUrl =
        "/cart/add?items[][id]=" +
        encodeURIComponent(variantId) +
        "&items[][quantity]=" +
        encodeURIComponent(quantity) +
        "&items[][selling_plan]=" +
        encodeURIComponent(sellingPlanId) +
        "&return_to=/checkout";

      window.location.href =
        "/cart/clear?return_to=" + encodeURIComponent(addUrl);
    });

    // Handles browser back/forward cache restores after checkout redirects.
    window.addEventListener("pageshow", resetCheckoutButtons);
    resetCheckoutButtons();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initRechargeCheckout);
  } else {
    initRechargeCheckout();
  }
})();

(function () {
  function initSideMenu() {
    const menu = document.querySelector("[data-appwiz-yash-menu]");
    if (!menu) {
      return;
    }

    const openButtons = document.querySelectorAll("[data-appwiz-yash-menu-open]");
    const closeButtons = menu.querySelectorAll(
      "[data-appwiz-yash-menu-close], [data-appwiz-yash-menu-overlay]",
    );
    const panel = menu.querySelector("[data-appwiz-yash-menu-panel]");
    const overlay = menu.querySelector("[data-appwiz-yash-menu-overlay]");
    const links = menu.querySelectorAll("a");
    let lastFocused = null;
    let previousBodyOverflow = "";

    function setOpen(isOpen) {
      menu.setAttribute("data-open", String(isOpen));
      menu.setAttribute("aria-hidden", String(!isOpen));
      if (panel) {
        panel.setAttribute("data-open", String(isOpen));
      }
      if (overlay) {
        overlay.setAttribute("data-open", String(isOpen));
      }

      openButtons.forEach((button) => {
        button.setAttribute("aria-expanded", String(isOpen));
      });

      if (isOpen) {
        lastFocused = document.activeElement;
        previousBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        const closeButton = menu.querySelector("[data-appwiz-yash-menu-close]");
        if (closeButton) {
          closeButton.focus();
        }
        return;
      }

      document.body.style.overflow = previousBodyOverflow;
      if (lastFocused && typeof lastFocused.focus === "function") {
        lastFocused.focus();
      }
    }

    openButtons.forEach((button) => {
      button.addEventListener("click", () => {
        setOpen(true);
      });
    });

    closeButtons.forEach((button) => {
      button.addEventListener("click", () => {
        setOpen(false);
      });
    });

    links.forEach((link) => {
      link.addEventListener("click", () => {
        setOpen(false);
      });
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && menu.getAttribute("data-open") === "true") {
        setOpen(false);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSideMenu);
  } else {
    initSideMenu();
  }
})();

(function () {
  const players = [];

  function pauseOtherVideos(activeVideo) {
    players.forEach((video) => {
      if (video !== activeVideo && !video.paused) {
        video.pause();
      }
    });
  }

  const PLAYER_TEMPLATE = `
    <video
      data-appwiz-yash-video
      class="h-full w-full object-cover"
      loop
      playsinline
      preload="none"
    >
      <source type="video/mp4" />
    </video>

    <button
      type="button"
      data-appwiz-yash-unmute-overlay
      class="absolute inset-0 z-10 flex cursor-pointer items-center justify-center border-0 bg-transparent"
      aria-label="Click to unmute video"
    >
      <div class="flex h-4/5 w-4/5 flex-col items-center justify-center gap-5 rounded-2xl bg-black/65 p-6 text-center text-white">
        <svg
          class="h-16 w-16 shrink-0 stroke-current sm:h-[5.5rem] sm:w-[5.5rem] lg:h-28 lg:w-28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="M11 5L6 9H2v6h4l5 4V5z" />
          <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
          <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
        </svg>
        <span data-appwiz-yash-unmute-text class="text-xl font-bold uppercase leading-tight tracking-wide sm:text-[1.75rem] lg:text-4xl"></span>
      </div>
    </button>

    <button
      type="button"
      data-appwiz-yash-center-play
      hidden
      class="absolute left-1/2 top-1/2 z-[15] flex h-[4.5rem] w-[4.5rem] -translate-x-1/2 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full border-0 bg-black/55 text-white transition-[background,transform] duration-200 hover:scale-105 hover:bg-black/70 sm:h-[5.5rem] sm:w-[5.5rem] [[hidden]]:hidden"
      aria-label="Play video"
    >
      <svg class="ml-1 h-8 w-8 sm:h-10 sm:w-10" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M8 5v14l11-7L8 5z" />
      </svg>
    </button>

    <div data-appwiz-yash-video-controls class="absolute bottom-0 left-0 z-20 p-3 sm:p-4">
      <button type="button" data-appwiz-yash-video-mute class="inline-flex items-center justify-center rounded-full bg-black/55 p-2.5 text-white transition-colors duration-200 hover:bg-black/70" aria-label="Unmute video">
        <svg data-appwiz-yash-video-icon-mute class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M11 5L6 9H2v6h4l5 4V5z" />
          <line x1="22" y1="9" x2="16" y2="15" />
          <line x1="16" y1="9" x2="22" y2="15" />
        </svg>
        <svg data-appwiz-yash-video-icon-unmute class="hidden h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M11 5L6 9H2v6h4l5 4V5z" />
          <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
          <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
        </svg>
      </button>
    </div>
  `;

  function parseBool(value, defaultValue) {
    if (value === undefined) {
      return defaultValue;
    }

    if (value === "" || value === "true" || value === "1") {
      return true;
    }

    if (value === "false" || value === "0") {
      return false;
    }

    return defaultValue;
  }

  function initVideoPlayer(root) {
    const src = root.dataset.appwizYashSrc;
    if (!src) {
      return;
    }

    const unmuteText = root.dataset.appwizYashUnmuteText || "Click to unmute";
    const showUnmuteOverlay = parseBool(
      root.dataset.appwizYashShowUnmuteOverlay,
      true,
    );
    const autoplay = parseBool(root.dataset.appwizYashAutoplay, true);
    const startMuted = parseBool(root.dataset.appwizYashMuted, true);
    const aspect = root.dataset.appwizYashAspect || "landscape";
    const poster = root.dataset.appwizYashPoster || "";

    root.classList.add("relative", "bg-neutral-900");

    if (aspect === "portrait") {
      root.classList.add("aspect-[9/16]");
    } else {
      root.classList.add("aspect-video");
    }
    root.innerHTML = PLAYER_TEMPLATE;

    root.querySelector("[data-appwiz-yash-video] source").src = src;
    root.querySelector("[data-appwiz-yash-unmute-text]").textContent =
      unmuteText;

    const video = root.querySelector("[data-appwiz-yash-video]");
    const unmuteOverlay = root.querySelector("[data-appwiz-yash-unmute-overlay]");
    const centerPlayBtn = root.querySelector("[data-appwiz-yash-center-play]");
    const muteBtn = root.querySelector("[data-appwiz-yash-video-mute]");
    const muteIcon = root.querySelector("[data-appwiz-yash-video-icon-mute]");
    const unmuteIcon = root.querySelector(
      "[data-appwiz-yash-video-icon-unmute]",
    );

    if (!video || !unmuteOverlay || !centerPlayBtn || !muteBtn) {
      return;
    }

    players.push(video);
    if (poster) {
      video.setAttribute("poster", poster);
    }
    // Pause when scrolled out of view (saves CPU/battery; autoplay resumes only on user action or re-init)
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting && !video.paused) {
              video.pause();
            }
          });
        },
        { threshold: 0 },
      ).observe(root);
    }
    video.muted = startMuted;
    if (autoplay) {
      video.autoplay = true;
    }

    let overlayDismissed = !showUnmuteOverlay || !startMuted;

    function setVisible(el, visible) {
      if (el) {
        el.classList.toggle("hidden", !visible);
      }
    }

    function updateCenterPlay() {
      centerPlayBtn.hidden = !(overlayDismissed && video.paused);
    }

    function updateMuteIcon() {
      const isMuted = video.muted;
      setVisible(muteIcon, isMuted);
      setVisible(unmuteIcon, !isMuted);
      muteBtn.setAttribute(
        "aria-label",
        isMuted ? "Unmute video" : "Mute video",
      );

      const shouldShowOverlay =
        showUnmuteOverlay && !overlayDismissed && isMuted;
      unmuteOverlay.classList.toggle("hidden", !shouldShowOverlay);
      root.classList.toggle("cursor-pointer", overlayDismissed);
      updateCenterPlay();
    }

    function togglePlayPause() {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    }

    function unmute() {
      video.muted = false;
      updateMuteIcon();
    }

    unmuteOverlay.addEventListener("click", (event) => {
      event.stopPropagation();
      overlayDismissed = true;
      unmute();
      if (video.paused) {
        video.play();
      }
    });

    centerPlayBtn.addEventListener("click", (event) => {
      event.stopPropagation();
      video.play();
    });

    root.addEventListener("click", (event) => {
      if (event.target.closest("[data-appwiz-yash-unmute-overlay]")) {
        return;
      }

      if (event.target.closest("[data-appwiz-yash-center-play]")) {
        return;
      }

      if (!overlayDismissed) {
        return;
      }

      if (event.target.closest("[data-appwiz-yash-video-controls]")) {
        return;
      }

      togglePlayPause();
    });

    muteBtn.addEventListener("click", (event) => {
      event.stopPropagation();
      video.muted = !video.muted;
      updateMuteIcon();
    });

    video.addEventListener("play", () => {
      pauseOtherVideos(video);
      updateCenterPlay();
    });
    video.addEventListener("pause", updateCenterPlay);

    updateMuteIcon();

    if (autoplay) {
      video
        .play()
        .then(updateCenterPlay)
        .catch(() => {
          if (!video.muted) {
            video.muted = true;
            updateMuteIcon();
          }

          video.play().then(updateCenterPlay).catch(updateCenterPlay);
        });
    }
  }

  // Core Web Vitals: build each player only when it is about to scroll into view, so
  // the MP4s (33 MB across the homepage) are not downloaded on page load.
  const videoRoots = Array.from(
    document.querySelectorAll("[data-appwiz-yash-video-player]"),
  );
  if ("IntersectionObserver" in window) {
    const lazyInit = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            lazyInit.unobserve(entry.target);
            initVideoPlayer(entry.target);
          }
        });
      },
      { rootMargin: "200px 0px" },
    );
    videoRoots.forEach((root) => lazyInit.observe(root));
  } else {
    videoRoots.forEach(initVideoPlayer);
  }
})();

document.addEventListener("DOMContentLoaded", () => {
  if (typeof Splide !== "undefined") {
    const heroSlider = document.getElementById("appwiz-yash-hero-slider");
    if (heroSlider) {
      new Splide("#appwiz-yash-hero-slider", {
        type: "loop",
        autoplay: true,
        interval: 4500,
        pauseOnHover: true,
        pauseOnFocus: true,
        arrows: true,
        pagination: true,
        speed: 600,
        gap: "1rem",
      }).mount();
    }

    const ingredientsSlider = document.getElementById(
      "appwiz-yash-ingredients-slider",
    );
    if (ingredientsSlider) {
      new Splide("#appwiz-yash-ingredients-slider", {
        mediaQuery: "min",
        type: "loop",
        focus: "center",
        perPage: 1,
        fixedWidth: "94%",
        gap: "0.75rem",
        padding: { left: "3%", right: "3%" },
        arrows: true,
        pagination: true,
        autoHeight: true,
        speed: 600,
        easing: "cubic-bezier(0.25, 1, 0.5, 1)",
        breakpoints: {
          768: {
            destroy: true,
          },
        },
      }).mount();
    }

    const reviewsSlider = document.getElementById("appwiz-yash-reviews-slider");
    if (reviewsSlider) {
      new Splide("#appwiz-yash-reviews-slider", {
        type: "loop",
        focus: "center",
        start: 1,
        perPage: 1,
        fixedWidth: "38rem",
        gap: "1.25rem",
        padding: { left: "16%", right: "16%" },
        arrows: true,
        pagination: false,
        autoHeight: false,
        speed: 800,
        easing: "cubic-bezier(0.25, 1, 0.5, 1)",
        updateOnMove: true,
        trimSpace: false,
        breakpoints: {
          767: {
            fixedWidth: "94%",
            padding: { left: "1%", right: "1%" },
            gap: "0.375rem",
            focus: "center",
          },
        },
      }).mount();
    }

    const portraitVideosSlider = document.getElementById(
      "appwiz-yash-portrait-videos-slider",
    );
    if (portraitVideosSlider) {
      new Splide("#appwiz-yash-portrait-videos-slider", {
        mediaQuery: "min",
        type: "loop",
        focus: "center",
        perPage: 1,
        fixedWidth: "94%",
        gap: "0.75rem",
        padding: { left: "3%", right: "3%" },
        arrows: true,
        pagination: false,
        speed: 800,
        easing: "cubic-bezier(0.25, 1, 0.5, 1)",
        updateOnMove: true,
        breakpoints: {
          768: {
            destroy: true,
          },
        },
      }).mount();
    }
  }

  document.querySelectorAll("[data-appwiz-yash-faq-toggle]").forEach((button) => {
    button.addEventListener("click", () => {
      const panelId = button.getAttribute("aria-controls");
      const panel = document.getElementById(panelId);
      if (!panel) {
        return;
      }

      const isExpanded = button.getAttribute("aria-expanded") === "true";
      button.setAttribute("aria-expanded", String(!isExpanded));
      panel.hidden = isExpanded;
    });
  });
});
